var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"alt":"Vue logo","src":require("./assets/logo.png")}}),_c('BaseIcon',{attrs:{"name":"success","width":"45","height":"40"}}),_c('BaseIcon',{attrs:{"name":"error","width":"45","height":"40"}}),_c('BaseIcon',{attrs:{"name":"info","width":"45","height":"40"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }